import * as firebase from 'firebase/app'

import { auth, db } from '../config/firebase'

export const getCampaigns = async () => {
  const userRef = await db.collection('users').doc(auth.currentUser.uid).get()
  const campaignData = userRef?.data()?.campaigns

  if (!campaignData) return []
  const campaignKeys = Object.keys(campaignData)

  return campaignKeys.map((campaignId) => {
    return { campaignId, campaignName: campaignData[campaignId] }
  })
}

export const setCampaign = async (campaignId, data = {}) => {
  return await db.collection('campaigns').doc(campaignId).set({
    ...data,
    updated: firebase.firestore.FieldValue.serverTimestamp()
  }, { merge: true })
}

export const becomeGM = async (campaignId) => {
  return await setCampaign(campaignId, { GM: auth.currentUser.uid })
}

export const removeGM = async (campaignId) => {
  return await setCampaign(campaignId, { GM: false })
}

export const addCampaignRegistration = async (userId, campaignId, campaignName) => {
  return await db.collection('users').doc(userId).set({
    campaigns: {
      [campaignId]: campaignName
    },
    updated: firebase.firestore.FieldValue.serverTimestamp()
  }, { merge: true })
}

export const createCampaign = async (campaignName) => {
  const campaignRef = db.collection('campaigns')

  console.log('[createCampaign] Checking for existing campaigns with name:', campaignName)
  const campaignNameQuerySnapshot = await campaignRef.where('owner', '==', auth.currentUser.uid).where('campaignName', '==', campaignName).get()

  if (campaignNameQuerySnapshot.length > 0) {
    throw new Error('You already have a campaign with this name!')
  }

  const timestamp = firebase.firestore.FieldValue.serverTimestamp()

  console.log('[createCampaign] Creating new campaign:', campaignName)

  const docRef = await campaignRef.add({
    campaignName,
    owner: auth.currentUser.uid,
    created: timestamp,
    updated: timestamp
  })

  await addCampaignRegistration(auth.currentUser.uid, docRef.id, campaignName)

  console.log('[createCampaign] Created campaign:', campaignName)

  return docRef
}
